export const version = process.env.VUE_APP_VERSION;
